<template>
    <div>
        <b-card title="Filtros">
            <div class="card-text">
                <b-row>
                    <b-col align-h="center" cols="12" md="4" lg="3">
                        <app-form-text-input placeholder="Nombre" v-model="filters.name" />
                    </b-col>
                    <b-col cols="6" md="4" lg="3">
                        <app-form-select-input 
                            placeholder="Perfil" 
                            :options="selectableProfiles" 
                            v-model="filters.profile" 
                        />
                    </b-col>
                    <b-col align-h="center" cols="12" md="4" lg="3">
                        <app-form-text-input placeholder="Nombre usuario" v-model="filters.username"/>
                    </b-col>
                    <b-col cols="12" md="4" lg="3">
                        <app-form-text-input placeholder="Documento" v-model="filters.document"/>    
                    </b-col>
                    <b-col cols="12" md="2" lg="1" offset-lg="10">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    data(){
        return {
            filters: {
                type: '',
                author: '',
                from: '',
                to: '',
                client: ''
            }
        }
    },
    computed: {
        ...mapGetters(['profiles']),
        selectableProfiles() {
            return this.profiles.filter(prof =>
                prof.slug === 'client-mobile-app' || prof.slug === 'cliente-admin' || prof.slug === 'contractor'
            );
        }
    },
    methods: {
        clearFilters(){
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    },
    created(){
        this.load('profiles');
    }
}
</script>


